import React from 'react'

export const GooglePlayIcon: React.FC = () => {
    const googlePlay = require<string>('./GooglePlay.png')

    return <img src={googlePlay} alt="GooglePlay Download" />
}

GooglePlayIcon.displayName = 'GooglePlayIcon'
